import React, { ChangeEvent, FC } from 'react'
import cn from '../../lib/utils/cn'
import Tooltip from './Tooltip'

interface CheckboxProps {
	label?: string
	checked: boolean
	onChange?: (
		checked: boolean,
		event: React.ChangeEvent<HTMLInputElement> & {
			nativeEvent: MouseEvent
		}
	) => void

	className?: string
	labelClassName?: string
	checkBoxClassName?: string
	disabled?: boolean
	tooltip?: string | null
	tooltipPosition?: 'top' | 'bottom' | 'left' | 'right'
}

const Checkbox: FC<CheckboxProps> = ({
	label,
	checked,
	onChange,
	className,
	labelClassName,
	checkBoxClassName,
	disabled = false,
	tooltip = null,
	tooltipPosition = 'top',
}) => {
	const checkboxContent = (
		<label
			className={cn(
				'flex items-center cursor-pointer select-none w-fit',
				disabled && 'cursor-not-allowed opacity-50',
				className
			)}
		>
			<div
				className={cn(
					'relative w-5 h-5 flex pointer-events-auto items-start justify-center border rounded-md box-border',
					checked
						? 'bg-accent border-accent'
						: 'bg-white dark:bg-background-dark border-stroke-dark',
					disabled &&
					'pointer-events-none cursor-not-allowed border-stroke-light dark:border-stroke-light-dark',
					checkBoxClassName
				)}
			>
				{checked && (
					<svg
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
						className="w-4 h-4 text-white"
					>
						<path d="M5 13l4 4L19 7" />
					</svg>
				)}
				<input
					type="checkbox"
					className="absolute w-full h-full opacity-0 cursor-pointer"
					checked={checked}
					onClick={(e) => e.stopPropagation()}
					onChange={(e) => {
						!disabled &&
							!!onChange &&
							onChange(
								!checked,
								e as React.ChangeEvent<HTMLInputElement> & {
									nativeEvent: MouseEvent
								}
							)
					}}
					disabled={disabled}
				/>
			</div>
			{label && (
				<span
					className={cn(
						'ml-2 text-sm text-text-main dark:text-text-main-dark',
						labelClassName
					)}
				>
					{label}
				</span>
			)}
		</label>
	)

	return tooltip ? (
		<Tooltip label={tooltip} position={tooltipPosition}>
			{checkboxContent}
		</Tooltip>
	) : (
		checkboxContent
	)
}

export default Checkbox
